
import { Link } from "react-router-dom";
import { User, Settings } from "lucide-react";

export const MobileUserSection = () => {
  return (
    <div className="p-3 border-b">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600">
          <User className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-medium">Welcome!</h3>
          <p className="text-xs text-gray-500">
            <Link 
              to="/profile" 
              className="text-emerald-600 hover:text-emerald-700 transition-colors"
            >
              View Profile
            </Link>
          </p>
        </div>
        <Link 
          to="/settings"
          className="p-2 text-gray-500 hover:text-emerald-600 transition-colors"
        >
          <Settings className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
};
